import { IDataProvider } from "@/store";
import { ReportTemplate } from "@/types/report/ReportTypes";

export interface IReportTemplateState {
  reportTemplate: ReportTemplate | null;
  reportTemplates: ReportTemplate[] | null;
  dataProvider: IDataProvider<ReportTemplate>;
}

export const state: IReportTemplateState = {
  reportTemplate: null,
  reportTemplates: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
